module.exports = __webpack_public_path__ + "img/escalierav.9782f771.png";